import { createContext } from 'react';

export interface SessionContextValue {
  sessionId: string;
}

export const SessionContext = createContext<SessionContextValue | null>(null);
